import { Component, ApplicationRef, OnInit, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService2 } from '../services/ws/ws.service';
import { WhiteBoardComponent } from "../white-board.component";
import { environment } from '../../../environments/environment';
import { SessionManagerService } from "../services/session/session-manager.service";
import { RecordingManagerService } from "../services/recording/recording-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import { LogService } from "../services/log/log.service";

import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";
import { Http } from '@angular/http';
declare var $;
declare var fabric;
declare var Decimal;
@Component({
  selector: "dskl-wb-fabric",
  templateUrl: 'fabric-wb.component.html',
  inputs: ["board"],//pageId", "sessionId", "boardId"],
  outputs: ["change", "onCurrentState"]
})

export class FabricWbComponent extends WhiteBoardComponent {
  // @ViewChild('whiteboard') el: ElementRef;
  isPoly() {
    for (let a of this.forms) {
      if (a.tool == this.currentTool)
        return true;
    }
    return false;
  }
  //SVG icons not wokring for some reason
  forms = [
    { icon: 'icon-line', tool: "LINE", tooltip: 'POLY_LINE' }, 
    { icon: 'icon-circle', tool: "CIRCLE", tooltip: 'POLY_CIRCLE'  }, 
    { icon: 'icon-triangle-90', tool: "TRIANGLE90", tooltip: 'POLY_T1'}, 
    { icon: 'icon-triangle-60', tool: "TRIANGLE60", tooltip: 'POLY_T2'}, 
    { icon: 'icon-triangle-30', tool: "TRIANGLE30", tooltip: 'POLY_T3'}, 
    { icon: 'icon-square', tool: "RECT", tooltip: 'POLY_RECT'}, 
    { icon: 'icon-rect2', tool: "RECT2", tooltip: 'POLY_RECT2'}, 
    { icon: 'icon-polygon', tool: "POLYGON", tooltip: 'POLY_POLYGON'}
  ] 
  getCurrentState() {
    var json =  this.canvas.toJSON();
    console.log("JSON is ", json);
    return json;
  }
  onCurrentPageState(state, pageId) {
    if (this.board.pageId == pageId) {
      console.log("Will set state in fabric")
      this.canvas.loadFromJSON(state);

    }
  }
  getWbType() {
    return "FABRIC";
  }
  constructor(private http: Http, private wsService: WsService2, private appRef: ApplicationRef, protected log: LogService, protected wbService: WbService, protected sessionManager: SessionManagerService, protected recordingMediaManager: RecordingManagerService, protected serviceManager: LayoutManagerService, protected permissionsManager: PermissionsManagerService) {
    super(log, wbService, sessionManager, serviceManager, permissionsManager);
  }
  onReady() {

  }
	openBottomTools() {
		$("#bottomtools").toggleClass("open");
		$("#wb-status.wb-status").toggleClass("open", false);
	}
  toolsKeys() {
    return Object.keys(this.tools);
  }
  currentColor = "#000000";
  onColor(e, color) {
    console.log("Got oclor", color)
    e.stopPropagation()
    this.currentColor = color;
    console.log(this.canvas)
    let obj = this.canvas.getActiveObject()
    if (obj){
      if (obj.type=='i-text') {
        obj.fill = this.currentColor;
        this.fixTexts(obj);
        this.canvas.renderAll()
        this.changed("fill", { id: obj.dsklid, o: color });
      } else {
       
      //obj.color = this.currentColor;
      if (obj.path)
      obj.set("stroke", this.currentColor)
      else
      obj.set("fill", this.currentColor)
      //obj.fill = this.currentColor;
    //  obj.stroke = this.currentColor;
      this.canvas.renderAll()
    }
    
  }
  if (this.canvas.freeDrawingBrush){
  this.canvas.freeDrawingBrush.color =this.currentColor;;
        this.canvas.renderAll()
  }
    // switch (this.currentTool) {
    //   case "LINE":
    //     this.canvas.Line.fill = color;
    //     break;
    //   case "RECT":
    //     this.canvas.Rect.fill = color;
    //     break;
    //   case "TRIANGLE":
    //    // this.canvas.Triangle.fill = color;
    //     break;
    //   case "CIRCLE":
    //     this.canvas.this.canvas.getSelectionContext().set("fill", "#f00");
    //     this.canvas.renderAll();
    //     break;
    //   case "PENCIL":
    //     this.canvas.freeDrawingBrush.color = color;
    //     break;
    // }

    console.log(e, color);
  }

  imageURLPrefix: 'a/assets/lc/img/';
  tools = {
    HAND: { lbl: "Ръчичка", pic: "pan.png" },
    "PENCIL": { lbl: "Молив", clazz: "Pencil", pic: "pencil.png" },

    LINE: { lbl: "Линия", pic: "line.png" },
    TEXT: { lbl: "Текст", pic: "text.png" },

    "RECT": { lbl: "Правоъгълник", clazz: "Rect", pic: "rectangle.png" },
    "CIRCLE": { lbl: "Окръжност", pic: "ellipse.png" },
    TRIANGLE: { lbl: "Триъгълник", pic: "triangle.png" },

    "RUBBER": { lbl: "Гума", clazz: "Color", pic: "eraser.png" },
    "REDO": { lbl: "Redo", clazz: "Color", pic: "redo.png" },
    "UNDO": { lbl: "Undo", clazz: "Color", pic: "undo.png" },

  };




  currentTool = "HAND"
  fontWeight = "normal";
  fontSize = 16;
  fontStyle = "normal";
  pencilWidth = 1.5;
  polySelected() {
    switch (this.currentTool) {
      case "CIRCLE":
      case "TRIANGLE90":
      case "TRIANGLE60":
      case "TRIANGLE30":
      case "RECT":
      case "POLYGON":
      case "LINE":
      case"RECT2":
        return true;
      default: return false;
    }
  }

  private turn(to) {
    var last
    this.canvas.forEachObject(function (object) {
      object.set('evented', to);
      object.set("selectable", to);
      object.setCoords();
    });
  }
  turnOffObjects() {
    this.turn(false);
  }
  turnOnObjects() {
    this.turn(true);
  }
  onPoly(p) {
    this.onTool(p.tool);
  }
  onTool(t) {
    this.imageSelected = null;
    var e;
    console.log("Will add " + t);
    this.currentTool = t;
    this.canvas.isDrawingMode = false;
    this.isDeleting = false;
    switch (t) {
      case "HAND":


        this.turnOnObjects();
        this.canvas.renderAll();
        break;
        case "RECT":
        case "RECT2":
      case "CIRCLE":
      case "POLYGON":
      case "LINE":
      case "TRIANGLE90":
      case "TRIANGLE60":
      case "TRIANGLE30":
        this.turnOffObjects(); break;
      case "PENCIL":
       this.canvas.deactivateAll().renderAll()
        this.canvas.isDrawingMode = true;
        this.canvas.freeDrawingBrush = new fabric['PencilBrush'](this.canvas);
        this.canvas.freeDrawingBrush.color = this.currentColor;
        this.canvas.freeDrawingBrush.width = this.pencilWidth;
        break;
      case "RUBBER":
        this.isDeleting = true;
        this.canvas.deactivateAll().renderAll();
        break;
      case "UNDO":
        this.undo(true);
        break;
      case "REDO":
        this.redo(true);
        break;
    }
    if (e) {

      this.canvas.add(e)
      this.canvas.renderAll();

      // this.addElement(e);
    }
    this.onResize();
  }
  width;
  lastZoom = new Decimal(1);

   plus(){
     this.lastZoom = this.lastZoom.mul(1.1)
     this.zoomIt(1.1);
    console.log("Last zoom is "+this.lastZoom)
     this.onResize();
   }
   
   minus(){ 
     
     this.lastZoom = this.lastZoom.mul(0.9);
     this.zoomIt(0.9);
     console.log("Last zoom is "+this.lastZoom)
     this.onResize();
   }
   private scaleMe(o){
      var orig = new Decimal(o);
      return orig.mul(this.lastZoom);
   }
   mul(a, b){
     return new Decimal(a).mul(new Decimal(b));
   }
   zoomIt(factor) {
    
   /// this.canvas.setHeight(this.mul(this.canvas.getHeight(), factor));
    //this.canvas.setWidth(this.mul(this.canvas.getWidth(), factor));
    if (this.canvas.backgroundImage) {
        // Need to scale background images as well
        var bi = this.canvas.backgroundImage;
        bi.width =this.mul( bi.width , factor); 
        bi.height = this.mul(bi.height , factor);
    }
    var objects = this.canvas.getObjects();
    for (var i in objects) {
      this.scale(objects[i], factor);
    }
    this.canvas.renderAll();
  this.canvas.calcOffset();
}


scale(o, factor, withEvent=true){
if (withEvent)
   this.setEventChanged(o, false);
    var scaleX = o.scaleX;
    var scaleY = o.scaleY;
    var left = o.left;
    var top = o.top;

    var tempScaleX = this.mul(scaleX , factor);
    var tempScaleY = this.mul(scaleY, factor);
    var tempLeft = this.mul(left , factor);
    var tempTop = this.mul(top , factor);

    o.scaleX = tempScaleX.toNumber();
    o.scaleY = tempScaleY.toNumber();
    o.left = tempLeft.toNumber();
    o.top = tempTop.toNumber();

    o.setCoords();
    if (withEvent)
     this.setEventChanged(o, true)
     console.log("Scalling");
}
  setToolWidth(w) {
    this.width = w;
    switch (this.currentTool) {
      case "LINE":
        break;
        case "POLYGON":
      case "RECT":
      case "RECT2":
      case "TRIANGLE90": 
      case "TRIANGLE60":
      case "TRIANGLE30":
      
      break;
      case "CIRCLE": break;
      case "PENCIL":
        this.canvas.freeDrawingBrush.width = w;
        break;
    }

  }

  isDeleting = false;
  loadFromStateStack(undo) {

    var self = this;
    if ((undo && self.top == 0) || (!undo && self.top == this.stateStack.length - 1)) return;
    if (undo) self.top--;
    else self.top++;
    console.log("StateStack: " + undo + " top: " + self.top + " statelength: " + this.stateStack.length)

    this.undoing = true;
    console.log("StateStack Will load " + this.top, this.stateStack[this.top])
    this.canvas.loadFromJSON(this.stateStack[this.top], function () {
      self.canvas.renderAll();
      self.undoing = false;

    });
  }
  undo(notify) {

    this.loadFromStateStack(true);
    /*var id = this.stack[this.top - 1].dsklid;
    this.removeElement(id)
    this.top--;
    */
    if (notify)
      this.changed("undo");
  }
  redo(notify) {

    /*var e = this.stack[this.top];
    if (!e) return;
    this.addElement(e, null, false);*/
    this.loadFromStateStack(false);
    if (notify)
    this.changed("redo");
  }
  removeElement(id) {

    this.canvas.remove(this.elements[id]);

  }
canUseTools(){
  return false;
}
  stack = [];
  top = -1;

  registerForEvents(e) {

    var self = this;
    this.setEvent(e, "selected", true);
    //this.setEvent(e, "selection:cleared", true);

    e.on("rotating", function (s) {
      console.log("rotating" + JSON.stringify(e));
      self.changed("rotating", { id: e.dsklid, o: e.angle });
    });
    /*e.on("object:rotating", function (s) {
      console.log("rotating" + JSON.stringify(e));
    });*/
    e.on("moving", function (s) {
      console.log("moving", JSON.stringify(e.left));
      self.changed("moving", { id: e.dsklid, o: { left: e.left, top: e.top } });
    });
    e.on("scaling", function (s) {
      console.log("scaling" + JSON.stringify(e));
      self.changed("scaling", { id: e.dsklid, o: { left: e.left, top: e.top, scaleX: e.scaleX, scaleY: e.scaleY } });
    });
    e.on("editing:entered", function (e) {
      console.log("entered ", JSON.stringify(e));
      var ooo = self.canvas.getActiveObject();
      if (ooo && ooo.type=="i-text"){
       self.fontWeight = ooo.fontWeight;
          // debugger
           self.fontStyle = ooo.fontStyle;
           self.textDecoration = ooo.textDecoration=='underline';
       self.currentTool ="TEXT";
       console.log("Current color is "+ooo.fill);
       self.currentColor = ooo.fill;
       self.fontSize= ooo.fontSize;
      // self.currentColor= ooo.currentColor;
      }
    });
    this.setEventChanged(e, true);
    e.on("editing:exited", function (e) {
      self.isWriting = false;
      // self.currentTool = "";

      //self.onTool("HAND");
      self.addToStateStack();
      console.log("exited ", JSON.stringify(e));
    });
    e.on("selection:changed", function (e) {
      console.log("selection ", JSON.stringify(e));
    });
    e.on("group:added", function (s) {
      self.changed("group:added", { parent: e, child: s.child })
      console.log("group added", JSON.stringify(s))
    })

  }
  setEventChanged(e, on) {
    var self = this;
    if (on) {
      e.on("changed", function () {
        console.log("changed ", JSON.stringify(e));
        self.changed("changed", { id: e.dsklid, o: e.getText() });

      });
    } else {
      e.off("changed");
    }


  }
  deleteElement(id, notify = true) {
    console.log("Deleting element ", this.elements[id]);
    this.canvas.remove(this.elements[id]);
    this.elements[id].off();
    this.canvas.renderAll();
    if (notify)
      this.changed("deleted", { id: id });
  }
  onBackToGroups() {
    console.log("Will go back to groups");
  }
  imageSelected = null;
  setCurrentFile(event){
    var url = environment.wbBackendUrl + "api/get/" + this.wsService.getMe() + "/contentHash";
    var self = this;
   
    $.ajax({
      url: url,
      method: "POST",
      success: function (data) {
        if (data && data.object && data.status){
        var teacherWbHash = data.object;
        console.log("Got event1 ", event);
        
      var url = environment.contentsBackendUrl + teacherWbHash + "/list/";
     
  
      
      self.http.post(url, {})
        .subscribe(data => {
          var materials = data.json();
          
          var materials = materials.contents;
          for (let f of materials){
            if (event && event.src){
              if (event.src.includes(f.content.nameUuid)){
                self.currentFile = f.content;
                self.sessionManager.currentFile = f.content;
                
                try{var fff =  event.src.split(f.content.nameUuid+"/")
                self.sessionManager.currentPage = Number.parseInt(fff[1].split(".")[0]);
                self.sessionManager.currentFile.page = self.sessionManager.currentPage
              }catch(err ){
                self.sessionManager.currentPage = 0;
              }
              }
            }
          }
          /*for (var f of materials.contents) {
            f["file"]=true;
            this.materials.push(f);  
          }*/
        })
        }
      }
    });
     
    
  }
  selected(event){
    console.log("Selected event", event);
    if (event._element && event._element.className=='canvas-img'){
      console.log("We got an image clicked here");
      this.imageSelected = event;
      this.setCurrentFile(event);
      this.sessionManager.currentFile = this.imageSelected.originalCurrentFile;
    }else{
      this.imageSelected = null;
    }
    var o = this.canvas.getActiveObject();
    if (o && o.fill){
      this.currentColor = o.fill;
    }
    // var ao = this.canvas.getActiveObject();
    // console.log(ao);
    // if (ao && ao["dsklidtool"]){
    //   this.onTool(ao["dsklidtool"])
    
    // }
  }
  imagePan(){
    if (!this.imageSelected.originalWidth){
      this.imageSelected.originalWidth = this.imageSelected.width;
      this.imageSelected.originalHeight = this.imageSelected.height;
      this.imageSelected.doriginTop = this.imageSelected.top;
      this.imageSelected.doriginLeft = this.imageSelected.left;
    }
    console.log("Current image selected is ", this.imageSelected);
    this.imageSelected.panned = !this.imageSelected.panned
    if (this.imageSelected.panned){
      
      var k;
      if (this.imageSelected.width>this.imageSelected.height)
        k = $(".canvas-container").width()/this.imageSelected.width/this.imageSelected.scaleX;
        else
        k = $(".canvas-container").height()/this.imageSelected.height/this.imageSelected.scaleX;
        console.log("Canvas container is",$(".canvas-container").width(), this.imageSelected.width);
      this.scale(this.imageSelected,k, false);//*this.imageSelected.width); 
      this.imageSelected.doriginalScale = 1/k;
      //this.imageSelected.setHeight(k*this.imageSelected.height);
      this.imageSelected.top = 0;
       this.imageSelected.left = 0;
       
    }else{
     // this.imageSelected.setWidth(this.imageSelected.originalWidth) 
     // this.imageSelected.setHeight(this.imageSelected.originalHeight);
       this.scale(this.imageSelected,this.imageSelected.doriginalScale*this.lastZoom, false);
     // this.imageSelected.scale( this.imageSelected.doriginalScale*this.lastZoom)
      this.imageSelected.top = this.imageSelected.doriginTop;
      this.imageSelected.left = this.imageSelected.doriginLeft;
    }
    this.imageSelected.trigger("scaling");
    this.canvas.renderAll();
    
  }
  setEvent(e, event, on) {
    if (on) {
      var self = this;
      e.on(event, function (s) {
        if (self.isDeleting) {
          self.deleteElement(e.dsklid);
          self.addToStateStack();
        } else {
          switch (event) {
            case "rotating": self.changed("rotating", { id: e.dsklid, o: e.angle }); break;
            case "moving": self.changed("moving", { id: e.dsklid, o: { left: e.left, top: e.top } }); break;
            case "scaling": self.changed("scaling", { id: e.dsklid, o: { left: e.left, top: e.top, scaleX: e.scaleX, scaleY: e.scaleY } }); break;
            case "selected": self.selected(e); //no break here please
            default: self.changed(event, e.dsklid); break;
          }

        }
      });
    } else {
      if (e)
        e.off(event);
    }
  }
  xOffset() {
    return 0;//$("#fabrictools").width()+50;
  }
  getResizeTopOffset() {
    return super.getResizeTopOffset() + 10;
  }
  onResize() {
    var h = window.innerHeight - this.getResizeTopOffset() - this.getResizeBottomOffset();
    console.log("Top offset is " + this.getResizeTopOffset());
    var w = $("#bottomtools").width() - this.xOffset()
    console.log("Height will be " + h);
    console.log("Width will be " + w);
    if (this.wsService.getFromMobile()){
    h = window.innerHeight;
    w = window.innerWidth;
    }
    // $(".canvas-container").css("border-left", "1px solid");
    // $(".upper-canvas ").css("height", h);
		// $("#fabrictools").css("height", h);
    $(".canvas-container").css("height", h);
    $(".canvas-container").attr("height", h);
    $(".canvas-container").css("width", w);
    $(".canvas-container").attr("width", w);

    /*$(".canvases").css("height", h);
    $(".canvases").attr("height", h);
    $(".canvases").css("width", w);
    $(".canvases").attr("width", w);
    */
    /*$("canvas").css("height", h);
    $("canvas").attr("height", h);

    $("canvas").css("width", w);
    $("canvas").attr("width", w);*/
    
    console.log("Graphic board will resize to ", h)
    this.canvas.setHeight(h);
    this.canvas.setWidth(w);
    if (this.canvas)
      this.canvas.renderAll();
  }
  canvas;

  elements = {};
  addId(p, idd = null) {
    var id;
    if (p.dsklid)
      id = p.dsklid
    else {
      do {
        id = Math.random();
      } while (this.elements[id]);

      p["dsklid"] = id;
      p['dsklidtool']=this.currentTool
    }
    this.elements[id] = p;
  }
  stateStack = [];
  undoing = false;
  addToStateStack() {
    if (!this.undoing) {
      this.top++;
      console.log("StateStack, adding to " + this.top, this.stateStack);

      this.stateStack = this.stateStack.splice(0, this.top);
      this.stateStack[this.top] = JSON.stringify(this.canvas);
    }
  }

  currentLine;
  isDrawing;
  isWriting;
  showSubTools= false;
  onViewReady() {


    this.canvas = new fabric.Canvas('c', { preserveObjectStacking: true, selection: false });
    /*fabric.Object.prototype.toObject = (function (toObject) {
      return function () {
        return fabric.util.object.extend(toObject.call(this), {
          dsklid: this.dsklid
        });
      };
    })(fabric.Object.prototype.toObject);
*/
fabric.Object.prototype.toObject = (function (toObject) {
    return function (propertiesToInclude) {
        propertiesToInclude = (propertiesToInclude || []).concat(
          ['dsklid']
        );
        return toObject.apply(this, [propertiesToInclude]);
    };
})(fabric.Object.prototype.toObject);
    var self = this;
    this.addToStateStack();
    this.canvas.on("object:modified", function (e) {
      console.log("Modified ", e.target);
      // self.addToStateStack();
    });
    this.canvas.on("object:added", function (e) {

      console.log("Added")
      //console.log(JSON.stringify(e));
      //self.addElement(e.target);

      if (!e.target.dsklid) {
        // self.addElement(e.target, null, true, true);
        self.addId(e.target);
        self.changed("added", { id: e.target.dsklid, o: JSON.stringify(e.target) });
      } else {
        self.addId(e.target);
      }
      self.registerForEvents(e.target);

      self.canvas.renderAll();

    });
    //var rect = new fabric.Rect();

    var self = this;

    var currentDrаwnObject;

    this.canvas.on('mouse:up', function (o) {
      currentDrаwnObject = null;
      switch (self.currentTool) {
        case "LINE":
        case "CIRCLE":
        case "POLYGON":
        case "RECT":
        case "RECT2":
        case "TRIANGLE90":
        case "TRIANGLE60":
        case "TRIANGLE30":
        case "PENCIL":
          self.addToStateStack();

      }
      var oob = self.canvas.getActiveObject()
     
      if (oob){
       
          var l = oob['dsklidtool'];
          switch (l) {
            case "LINE":
            case "CIRCLE":
            case "POLYGON":
            case "RECT":
            case "RECT2":
            case "TRIANGLE90":
            case "TRIANGLE60":
            case "TRIANGLE30":
            case "PENCIL":
            self.showSubTools = true; break
            default: self.showSubTools = false;
    }
  }
      self.canvas.renderAll();
    });/*   self.isDown = false;
     if (self.currentTool == "LINE") {

        console.log(line)
        var newLine = new fabric.Line([line.x1, line.y1, line.x2, line.y2], {
          strokeWidth: 5,
          fill: self.currentColor,
          stroke: self.currentColor,
        })
        self.deleteElement(line.dsklid)
        self.canvas.add(newLine)


        self.canvas.renderAll()
      }*/

    // if (self.currentTool == "POLYGON") {
    //   self.canvas.setActiveObject(line)
    //   self.canvas.forEachObject(function (object) {
    //     object.selectable = true;
    //   });
    //   self.canvas.renderAll()
    // }

    // if (self.currentTool == "CIRCLE") {

    //   self.canvas.setActiveObject(line)
    //   self.canvas.forEachObject(function (object) {
    //     object.selectable = true;
    //   });
    //   self.canvas.renderAll()
    // }
    /* if (self.currentTool != 'PENCIL' && self.currentTool != 'RUBBER' && self.currentTool != 'LINE' && self.currentTool != 'HAND')  {
       self.isDown = false;
       self.isDrawing = false;
      // self.canvas.selection = true;
       if (line) {
         let a = self.canvas.getActiveObject()
         let copy = a.clone()
         self.removeElement(a.dsklid)
         self.canvas.add(copy)
        // a.active = true;
       //  self.canvas.setActiveObject(copy)
       }

       self.canvas.renderAll()
       self.onTool("HAND")
     }
   });*/

    this.canvas.on("mouse:move", function (o) {
     
      // if (!self.isDrawing) return;
      if (!self.isDown || !currentDrаwnObject) return;
      //var object = self.canvas.getActiveObject();

      var mouse = self.canvas.getPointer(o.e)

      if (self.currentTool == "LINE") {
        currentDrаwnObject.set({ x2: mouse.x, y2: mouse.y });
        console.log("currentDrаwnObject is", currentDrаwnObject);

        self.changed("scaling", {
          id: currentDrаwnObject.dsklid, o: {

            x1: currentDrаwnObject.x1,
            x2: currentDrаwnObject.x2,
            y1: currentDrаwnObject.y1,
            y2: currentDrаwnObject.y2,
            top: currentDrаwnObject.top,
            left: currentDrаwnObject.left,
            width: currentDrаwnObject.width,
            height: currentDrаwnObject.height
          }
        })
        // self.changed("scaling", { id: currentDrаwnObject.dsklid, o: self.elements[currentDrаwnObject.dsklid] })
      }
      switch (self.currentTool){
        case "TRIANGLE90":
        case "TRIANGLE60":
        case "TRIANGLE30":
        var w = mouse.x - currentDrаwnObject.left
        var h = mouse.y - currentDrаwnObject.top;
        if (!w || !h) {
          return false;
        }
       
        
        
       // currentDrаwnObject.set("width", w);
       // currentDrаwnObject.setCoords();
       // currentDrаwnObject.scaleToHeight(h);
        //self.changed("pmodify", { id: currentDrаwnObject.dsklid, o: ps })
        
      }

      /*if (self.currentTool == "POLYGON" || self.currentTool == "TRIANGLE") {
        
      }*/
      if (self.currentTool == "CIRCLE") {
        currentDrаwnObject.set('radius', Math.abs(mouse.x - currentDrаwnObject.left))
        self.changed("scaling", { id: currentDrаwnObject.dsklid, o: currentDrаwnObject })
      }
      self.canvas.renderAll()
    });

    this.canvas.on("mouse:down", function (o) {
      self.isDown = true;
      

      var e;
      var pointer = self.canvas.getPointer(o.e);
      
      console.log("Current tool is ", self.currentTool);
      
      switch (self.currentTool) {
        case 'TRIANGLE90':
        case 'TRIANGLE60':
        case 'TRIANGLE30':
        case 'RECT': 
        case 'RECT2': 
        case "POLYGON":
        var tps;
          switch (self.currentTool){
            case 'TRIANGLE90': tps = [ {x:0, y:0},  {x: 100, y: 0} ,{x:0, y: -100}]; break;
            case 'TRIANGLE60':tps =  [{x:0, y:0},  {x: 100, y: 0} ,{x:50, y: 100}]; break;
            case 'TRIANGLE30':tps =  [{x:0, y:0},  {x: 100, y: 0} ,{x:50, y: -150}]; break;
            case 'RECT':tps =  [{x:0, y:0},  {x: 100, y: 0} ,{x:100, y: 100}, {x:0, y: 100}]; break;
            case 'RECT2': tps =  [{x:0, y:0},  {x: 120, y: 0} ,{x:100, y: -100}, {x:20, y: -100}]; break;
            case 'POLYGON': tps =  [{x:0, y:0},  {x: 100, y: 100} ,{x:200, y: 100}, {x:300, y: 0},{x:200, y: -100}, {x:100, y: -100}]; break;
          }
          currentDrаwnObject = new fabric.Polygon(tps, {
           // width: 50,
           // height: 50,
            left: pointer.x,
            top: pointer.y,
            fill: null,
            stroke: self.currentColor,
            opacity: 0.5
          }, false)
          
          break;
        case 'CIRCLE':
          // self.canvas.selection = false;

          //  self.isDrawing = true;
          currentDrаwnObject = new fabric.Circle({
            radius: 0,
            left: pointer.x,
            top: pointer.y,
            stroke: "#000",
            fill: self.currentColor,
            opacity: 0.5
          });

          break;
        case "POLYGON":

          self.isDrawing = true;
          self.canvas.selection = false;
          currentDrаwnObject = new fabric.Rect({
            width: 0,
            height: 0,
            left: pointer.x,
            top: pointer.y,
           fill: "#fff",
           opacity: 0.5,
            stroke: self.currentColor
          })

          break;
        case "LINE":


          var points = [pointer.x, pointer.y, pointer.x, pointer.y];
          // self.isDrawing = true;
          currentDrаwnObject = new fabric.Line(points, {
            strokeWidth: 5,
            fill: self.currentColor,
            stroke: self.currentColor,
            originX: 'center',
            originY: 'center',
            left: pointer.x,
            top: pointer.y
          });

          //   line.set('seletable', false);
          // self.canvas.selection = false;
          // self.canvas.isDrawingMode = true
          // self.canvas.deactivateAll();
          // self.canvas.add(line)
          // self.canvas.renderAll();


          // self.canvas.setActiveObject(line)
          // line.set('evented', false);
          // line.set('selectable', false);
          //  currentDrownObject = line;
          break;
        case "TEXT":
        var ooo = self.canvas.getActiveObject();
        if (!ooo){
          var pointer = self.canvas.getPointer(o.e)
          currentDrаwnObject = new fabric.IText(' ', {
            left: pointer.x,
            top: pointer.y,
            width: 400,
            fontFamily: 'Helvetica',
            fill: self.currentColor,
            fontWeight: self.fontWeight,
            fontStyle: self.fontStyle,
            fontSize: self.fontSize,
            textDecoration: self.textDecoration?"underline":''
          });
          
        }/*else{
          currentDrаwnObject = ooo;
          self.fontWeight = ooo.fontWeight;
         // debugger
          self.fontStyle = ooo.fontStyle;
          self.textDecoration = ooo.textDecoration=='underline';
        }*/
          break;

      }
      self.currentObject = currentDrаwnObject
      if (currentDrаwnObject) {

        currentDrаwnObject.set('evented', false);
        currentDrаwnObject.set('selectable', false);

        self.canvas.add(currentDrаwnObject)
        if (self.currentTool == "TEXT") {
          self.canvas.setActiveObject(currentDrаwnObject);
          currentDrаwnObject.enterEditing();
          currentDrаwnObject.hiddenTextarea.focus();
        }
        self.canvas.renderAll();
        switch (self.currentTool){
          case "TRIANGLE30":
          case "TRIANGLE60":
          case "TRIANGLE90":
          case "RECT":
          case "RECT2":
          case "POLYGON":
          self.canvas.selection = true;
          currentDrаwnObject.set('selectable', true);
          self.canvas.setActiveObject(currentDrаwnObject);
          self.onTool("HAND");
        }

      }/*
      if (e && self.currentTool == "TEXT" && !self.isWriting) {
        var objs = self.canvas.getObjects()
       // var isChild = false;
        self.canvas.add(e);
        self.canvas.setActiveObject(e);
       // self.isWriting = true;
        e.enterEditing();

        e.on("editing:exited", function () {
          console.log('objects', objs)
          for (var obj of objs) {
            if (e.isContainedWithinObject(obj) && (obj.type == 'image' || obj.type == 'group')) {
              console.log(obj)
              if (obj.type == 'image') {
                var newObj = new fabric.IText(e.text, {
                  left: e.left,
                  top: e.top,
                  fontFamily: e.fontFamily,
                  fill: e.fill,
                  fontWeight: e.fontWeight,
                  fontStyle: e.fontStyle,
                  fontSize: e.fontSize
                });
                var group = new fabric.Group();
                group.addWithUpdate(fabric.util.object.clone(obj))
                group.addWithUpdate(e.clone())
                self.deleteElement(e.dsklid);
                self.deleteElement(obj.dsklid);
                self.canvas.add(group);
                group.trigger("group:added", { child: newObj })
                self.canvas.setActiveObject(group);
                self.canvas.renderAll();
              }
              if (obj.type == 'group') {
                var newObj = new fabric.IText(e.text, {
                  left: e.left,
                  top: e.top,
                  fontFamily: e.fontFamily,
                  fill: e.fill,
                  fontWeight: e.fontWeight,
                  fontStyle: e.fontStyle,
                  fontSize: e.fontSize
                });
                obj.trigger("group:added", { child: e.dsklid })
                obj.addWithUpdate(e.clone());
                self.canvas.remove(e)
              }
            }
          }
        })
      }*/
    })

    // this.canvas.add(rect); // add object
    this.onResize();
  }
  textDecoration = false
  temps = [];
  isDown = false;
  setTextDecoration(d){
    this.setParamsOfText(false, false, false, false, true, d);
  }
  setFontStyle(e, italic) {
    this.setParamsOfText(false, false, true, italic, false, false);
   /* console.log(italic)
    if (italic)
      this.fontStyle = "italic";
    else
      this.fontStyle = "normal";*/
  }
  currentObject=null;
  setFontSize(size) {
    this.fontSize = size;
    this.currentObject = this.canvas.getActiveObject();
     // this.canvas.setActiveObject(this.currentObject);
    // debugger
     if (this.currentObject){ 
       if (this.currentObject.type=="i-text"){
        this.currentObject.fontSize = this.fontSize;
        this.canvas.renderAll();
        this.changed("fontSize", { id: this.currentObject.dsklid, o: this.fontSize });
       }
     }
  }
  setParamsOfText(weight,bold, style, italic, textDecoration, underline){
    this.currentObject = this.canvas.getActiveObject();
     // this.canvas.setActiveObject(this.currentObject);
    // debugger
     if (this.currentObject){ 
      this.currentObject.enterEditing();
      this.currentObject.hiddenTextarea.focus()
     }
      if (weight){
        if (bold)
            this.fontWeight = "bold";
        else
            this.fontWeight = "normal";
      if (this.currentObject)
        this.currentObject.fontWeight = this.fontWeight;
        this.changed("fontWeight", { id: this.currentObject.dsklid, o: this.fontWeight });
      }
      if (style){
        if (italic)
        this.fontStyle = "italic";
      else
        this.fontStyle = "normal";
        if (this.currentObject){ 
          this.currentObject.fontStyle  = this.fontStyle;
          this.changed("fontStyle", { id: this.currentObject.dsklid, o: this.fontStyle });
        }
      }
      if (textDecoration){
        this.textDecoration = underline;
        if (this.currentObject){ 
          this.currentObject.textDecoration = (underline?"underline":'');
          var fs = this.currentObject.fontStyle;
          this.currentObject.fontStyle  = "normal";
          this.changed("textDecoration", { id: this.currentObject.dsklid, o: underline?"underline":'' });
          //this.currentObject.fontStyle  =  fs;
          this.fixTexts(this.currentObject);
        }
        
      }
      this.canvas.renderAll();
  }
  setFontWeight(e, bold) {
    this.setParamsOfText(true, bold, false, false, false, false);
    /*
      this.currentObject = this.canvas.getActiveObject();
      this.canvas.setActiveObject(this.currentObject);
      this.currentObject.enterEditing();
      this.currentObject.hiddenTextarea.focus()
      if (bold)
          this.fontWeight = "bold";
      else
          this.fontWeight = "normal";
      this.currentObject.fontWeight = this.fontWeight;
      this.canvas.renderAll();*/
/*
      currentDrаwnObject = new fabric.IText(' ', {
        left: pointer.x,
        top: pointer.y,
        width: 400,
        fontFamily: 'Helvetica',
        fill: self.currentColor,
        fontWeight: self.fontWeight,
        fontStyle: self.fontStyle,
        fontSize: self.fontSize,
      });*/
   // }
   
  }
  pageName = " Графична дъска2"
  changing: boolean = false;
  currentFile;
  showFile(f) {
    if (f.media) return;
    var self = this;
    console.log("File has been loaded ", f);
    var src = environment.contentsBackendUrl + environment.contentsFileMapping + f.nameUuid + "/" + f.page + ".png";
    fabric.Image.fromURL(src, function (oImg) {

      //    oImg.scale(0.2);
      oImg.set({ 'left': 0 });
      oImg.set({ 'top': 0 });

      console.log("Will show file", oImg)
      oImg.originalCurrentFile = self.sessionManager.currentFile;
      //  oImg.width =  self.lastZoom.mul(new Decimal(oImg.width)).toNumber();
      // oImg.height =  self.lastZoom.mul(new Decimal(oImg.height)).toNumber();
      oImg.setCoords();
      self.canvas.add(oImg);
      oImg.setCoords();
      // self.addElement(oImg);
      self.canvas.setActiveObject(oImg);
      
      
     //self.setEvent(oImg, "scaling", false);
     self.scale(oImg, self.lastZoom);
     self.canvas.renderAll();
  self.canvas.calcOffset();
     //self.setEvent(oImg, "scaling", true);
      //self.canvas.add(oImg);
    });

    // this.lc.saveShape(LC.createShape('Image', {x: 0, y: 0, image: image}))
  }
  private div(a, b){
    return new Decimal(a).div(new Decimal(b));
  }
private addForState(a, othersScale){
  return new Decimal(a).mul(this.lastZoom).div(othersScale).toNumber();
}
  private addE(w, fromOnState=false) {
    var self = this;
    var o = JSON.parse(w.value.o);
    var scale = w.scale;
    console.log("Scale is "+scale);
    var isImage = o.type=='image';
    if (fromOnState){
     
        if (typeof o["x1"] != 'undefined'){
          o["x1"]=this.addForState(o["x1"], scale);
          o["y1"]=this.addForState(o["y1"], scale);
        }
        if (typeof o["x2"] != 'undefined'){
          o["x2"]=this.addForState(o["x2"], scale);
          o["y2"]=this.addForState(o["y2"], scale);
        }
        if (typeof o["width"] != 'undefined'){
          o["width"]=this.addForState(o["width"], isImage?1:scale);
          o["height"]=this.addForState(o["height"], isImage?1:scale);
        }
        if (typeof o["top"] != 'undefined'){
          o["top"]=this.addForState(o["top"], isImage?1:scale);
          o["left"]=this.addForState(o["left"], isImage?1:scale);
        }
         if (typeof o["radius"] != 'undefined'){
          o["radius"]=this.addForState(o["radius"], scale);
         
        }
       // if (typeof o["scaleX"] != 'undefined'){
          o["scaleX"] = this.lastZoom.div(isImage?1:scale).toNumber();
          o["scaleY"] = this.lastZoom.div(isImage?1:scale).toNumber();
        //}
    }
    if (o.target)
      o = o.target
    fabric.util.enlivenObjects([o], function (os) {
      var origRenderOnAddRemove = self.canvas.renderOnAddRemove;
      self.canvas.renderOnAddRemove = false;
      self.canvas.add(os[0]);
      //self.addId(os[0], w.value.id);
      //self.registerForEvents(os[0]);
      //self.addElement(os[0], w.value.id, false);

      self.canvas.renderOnAddRemove = origRenderOnAddRemove
      self.canvas.renderAll();
    });
  }
  clearStates() {
    console.log("Will clear states");
    this.addToStateStack();
    this.canvas.clear();
    this.changed("clear");
    this.canvas.renderAll();
  }
  fixTexts(o){
    var tw = o.fontWeight;
        o.fontWeight = tw=="normal"?"bold":"normal";
        this.canvas.renderAll();
        o.fontWeight = tw=="normal"?"bold":"normal";
        o.fontWeight=tw;
        
  }
  onState(state, pageId) {

    if (pageId != this.board.pageId) {
      console.log("Not for me " + this.board.pageId + " but for " + pageId);
      console.log(state);
      return;
    }
    var w = state;
    console.log("Got state ", w);
    //w = JSON.parse(w);
    var self = this;
    switch (w.type) {
      case "clear":
        this.canvas.clear();
    
    this.canvas.renderAll();
      break;
      case "resize":
        var o = this.elements[w.value.id];
        switch (w.value.o.type) {
          case "LINE":
            o.x1 = w.value.o.x1;
            o.x2 = w.value.o.x2;
            o.y1 = w.value.o.y1;
            o.y2 = w.value.o.y2;
            o.top = w.value.o.top;
            o.left = w.value.o.left;
            o.width = w.value.o.width;
            o.height = w.value.o.height;
            break;
        }

        this.canvas.renderAll();
        break;
      case 'selection:add':
        console.log(w)
        self.canvas.setActiveGroup(new fabric.Group(w.value)).renderAll();
      case "group:added":
        // var parent = this.elements[w.value.parent.dsklid];
        // var child = this.elements[w.value.child]
        // console.log(child)
        // parent.addWithUpdate(child.clone())
        // self.canvas.remove(child)
        break;
        case "fontWeight":
        var o = this.elements[w.value.id];
        o.fontWeight = w.value.o;
        break;
        case "fontStyle":
        var o = this.elements[w.value.id];
        o.fontStyle = w.value.o;
        break;
        case "fontSize":
        var o = this.elements[w.value.id];
        o.fontSize = w.value.o;
        break;
        case "fill":
        var o = this.elements[w.value.id];
        console.log("Fill is "+o.fill)
        o.fill = w.value.o;
        this.fixTexts(o);
        this.canvas.renderAll();
        break;
        case "textDecoration":
        var o = this.elements[w.value.id];
        o.textDecoration = w.value.o;
        this.fixTexts(o);
        break;
       
      case "added":
       
        this.addE(w, true);
        break;
      case "selected":

        var o = this.elements[w.value];
        if (!o) return;
        
       
        this.setEvent(o, "selected", false);
        this.canvas.setActiveObject(o);
        this.setEvent(o, "selected", true);
        break;
      case "selection:cleared":
      this.imageSelected = null;
        var o = this.elements[w.value];
        this.setEvent(o, "selection:cleared", false);
        this.canvas.setActiveObject(null);
        this.setEvent(o, "selection:cleared", true);
        break;
      case "pmodify":
        this.elements[w.value.id].set('points', w.value.o); 
        this.canvas.renderAll();
        break;
      case "rotating":
        this.elements[w.value.id].setAngle(w.value.o); this.canvas.renderAll();
        break;
      case "moving":
        console.log("Will move", w);
        var a = this.elements[w.value.id];

        this.setEvent(a, "moving", false);
        if (a) {
          a.setLeft(this.addForState(w.value.o.left, w.scale));
          a.setTop(this.addForState(w.value.o.top, w.scale));
          console.log(a);
          this.setEvent(a, "moving", true);
        }
        this.canvas.renderAll();
        break;
      case "scaling":
        var a = this.elements[w.value.id];

        this.setEvent(a, "scaling", false);
        //a.set("left", w.value.o.left);
        //a.set("top", w.value.o.top);
        
        a.setLeft(this.addForState(w.value.o.left, w.scale));
        a.setTop(this.addForState(w.value.o.top, w.scale));
      
        if (w.value.o.radius) {
          a.set('radius', this.addForState(w.value.o.radius, w.scale))
         // a.set('radius', w.value.o.radius);
        }
        if (w.value.o.x2 && w.value.o.y2) {
          a.set("x2", this.addForState(w.value.o.x2, w.scale));
          a.set("y2", this.addForState(w.value.o.y2, w.scale));
         // a.set("x2", w.value.o.x2);
         // a.set("y2", w.value.o.y2);
        }
        if (w.value.o.x1 && w.value.o.y1) {
          a.set("x1", this.addForState(w.value.o.x1, w.scale));
          a.set("y1", this.addForState(w.value.o.y1, w.scale));
         // a.set("x1", w.value.o.x1);
         // a.set("y1", w.value.o.y1);
        }
        if (w.value.o.width && w.value.o.height) {
          //a.set("width", this.addForState(w.value.o.width, w.scale));
          //a.set("height", this.addForState(w.value.o.height, w.scale));
          a.set("width", w.value.o.width);
          a.set("height", w.value.o.height);
        }
        if (w.value.o.scaleX) {
          a.setScaleX(new Decimal(w.value.o.scaleX).mul(this.lastZoom.div(new Decimal(w.scale))));
          a.setScaleY(new Decimal(w.value.o.scaleY).mul(this.lastZoom.div(new Decimal(w.scale))));
        }
        console.log(a)

        this.setEvent(a, "scaling", true);
        this.canvas.renderAll();

        break;
      case "changed":
        var o = this.elements[w.value.id];
        this.setEventChanged(o, false);
        o.setText(w.value.o);
        this.setEventChanged(o, true);

        break;
      case "deleted":

        this.deleteElement(w.value.id, false);
        break;
      case "undo":
        this.undo(false);
        break;
      case "redo":
        this.redo(false);
        break;
    }
    this.canvas.renderAll();

  }
  private changed(type, value = null) {
    console.log("Trying to update state ", value)
    this.emitChanged({ type: type, value: value, scale: this.lastZoom });

  }


  private bindWolframOnLoadEvent(selector) {
    console.log($(selector))
    $("#loading").show()
    let self = this;
    $(selector).on('error', function () {
      $("#loading").hide()
      $("#wolframError").show()
      $('#result').hide()
      $('#importButton').hide()

    })

    $(selector).on('load', () => {
      $("#loading").hide()
      $("#wolframError").hide()
      $('#importButton').show()
      $('#result').show()
    })
  }

  public wolframError;
  public wolframResult;
  public wolframQuery(input) {
    console.log(input)
    this.wolframResult = null;
    $("#wolframError").hide()
    var self = this;

    $("#loading").show()
    // fabric.Image.fromURL(environment.wolframUrl+input.replace(" ", "+"), function (oImg) {

    //   oImg.set({ 'left': 0 });
    //   oImg.set({ 'top': 0 });
    //   self.canvas.add(oImg);

    //   self.canvas.setActiveObject(oImg);
    // });

    this.wolframResult = environment.wbBackendUrl+"wf/"+input.replace(" ", "+");
    this.bindWolframOnLoadEvent("#resultImg")
  }

  wolframImgToBoard() {
    let self = this;
    fabric.Image.fromURL(this.wolframResult, function (oImg) {

      //    oImg.scale(0.2);
      oImg.set({ 'left': 0 });
      oImg.set({ 'top': 0 });
      oImg.width =  self.lastZoom.mul(new Decimal(oImg.width)).toNumber();
       oImg.height =  self.lastZoom.mul(new Decimal(oImg.height)).toNumber();
      self.canvas.add(oImg);
      // self.addElement(oImg);
      self.canvas.setActiveObject(oImg);
      //self.canvas.add(oImg);
    });
  }

  imgExport() {
    if (!fabric.Canvas.supports('toDataURL')) {
      alert('This browser doesn\'t provide means to serialize canvas to an image');
    } else {
       var a = document.createElement("a"),
                url = this.canvas.toDataURL();
        a.href = url;
        a.download = 'image';
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);

      // window.open(this.canvas.toDataURL({ format: 'png' }));
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/wb/fabric/fabric-wb.component.ts